import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { APP_STATE } from 'services/Define';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import Navbar from 'examples/Navbars/NavBar';
import { Grid, Card, Backdrop, CircularProgress, Menu, MenuItem, TableCell } from '@mui/material';
import * as Func from 'services/Function';
import { FetchData } from 'services/Request';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import TableHeader from 'components/Table/TableHeader';
import MDInput from 'components/MDInput';
import InputAdornment from '@mui/material/InputAdornment';
import Icon from '@mui/material/Icon';
import MenuItemMui from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import MDDateRange from 'components/MDDateRange';
import Pagination from '@mui/material/Pagination';
import MDButton from 'components/MDButton';

const initFind = {
  search: '',
  order_by: 'vp.barcode',
  order_sort: 'desc',
  page: 1,
  perPage: 10,
  pageTotal: 0,
  period: 'ALL',
  branch: '',
  status: 'success',
  date_start: Func.dateTimeFirstMonth(),
  date_stop: Func.dateTimeEndMonth(),
};

const initSummary = {
  quantity: '',
  total: '',
  nettotal: '',
  vat: '',
  discount_all: '',
};

function RPDOH() {
  const mod = 'rp_doh';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [find, setFind] = useState(initFind);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(null);
  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);
  const [summary, setSummary] = useState(initSummary);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [cboBranch, setCboBranch] = useState([]);
  const [cboStatus, setCboStatus] = useState([]);
  const [urlExcel, setUrlExcel] = useState('');
  const [excelLoading, setExcelLoading] = useState(false);

  const initHeader = [
    { id: 'branch_name', label: 'สาขา', align: 'left' },
    { id: 'sku', label: 'รหัสสินค้า', align: 'left' },
    { id: 'product_name', label: 'ชื่อสินค้า', align: 'left' },
    { id: 'unit_name', label: 'หน่วย', align: 'left' },
    { id: 'quantity_balance', label: 'Stock สาขา', align: 'right' },
    { id: 'quantity', label: 'จำนวน', align: 'right' },
    { id: 'total', label: 'ยอดขาย', align: 'right' },
    { id: 'rank', label: 'อันดับ', align: 'right' },
    { id: 'avg_qty', label: 'จำนวนเฉลี่ย', align: 'right' },
    { id: 'min_doh', label: 'จำนวนวันต่ำสุด', align: 'right' },
    { id: 'max_doh', label: 'จำนวนวันสูงสุด', align: 'right' },
    { id: 'min_qty', label: 'จำนวนเฉลี่ยต่ำสุด', align: 'right' },
    { id: 'max_qty', label: 'จำนวนเฉลี่ยสูงสุด', align: 'right' },
  ];

  const view = (data) => {
    if (data.branch.length === 0) {
      return;
    }

    setFind(data);
    setLoading(true);
    setRecord([]);
    closeShow();

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang || 'th',
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
      branch: data.branch,
      period: data.period,
      date_start: data.date_start,
      date_stop: data.date_stop,
      status: data.status,
    }).then((result) => {
      console.log('view', result);
      if (result.status === 'ok') {
        setRecord(result.data);

        setPageTotal(result.total_pages);
        setPageNo(result.page);

        setSummary(result.summary);
      }
      setLoading(false);
    });
  };

  const setDateRange = (start, stop) => {
    view({
      ...find,
      date_start: Func.dateTimeFormat(start.toDate()),
      date_stop: Func.dateTimeFormat(stop.toDate()),
      page: 1,
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? 'desc' : 'asc' });
  };

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang || 'th',
    }).then((result) => {
      if (result.status === 'ok') {
        setCboBranch(result.branch);
        setCboStatus(result.stepper);
        setUrlExcel(result.excel);
        view(find);
      } else {
        // Func.exitApp();
      }
    });
  };

  const excel = () => {
    setExcelLoading(true);

    const params = new URLSearchParams();
    params.append('search', find.search);
    params.append('branch', find.branch);

    const url = `${urlExcel}/download?${params.toString()}`;

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;

    iframe.onload = () => {
      setExcelLoading(false);
      document.body.removeChild(iframe);
    };

    iframe.onerror = () => {
      setExcelLoading(false);
      document.body.removeChild(iframe);
    };

    document.body.appendChild(iframe);

    setTimeout(() => {
      setExcelLoading(false);
    }, 1000);
  };

  const renderSearch = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDBox
              noValidate
              component='form'
              role='form'
              onSubmit={(e) => {
                e.preventDefault();
                view({ ...find, period: 'ALL', page: 1 });
              }}
            >
              <MDInput
                name='searchform'
                fullWidth
                value={find.search}
                type='search'
                onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>{t('element.search')} :</InputAdornment>
                  ),
                  autoComplete: 'off',
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDInput
              select
              fullWidth
              value={find.branch}
              onChange={(e) => {
                view({ ...find, branch: e.target.value, page: 1 });
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>{t('menu.branch')} :</InputAdornment>
                ),
              }}
            >
              <MenuItem value='ALL'>ทั้งหมด</MenuItem>
              {cboBranch.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <MDBox display='flex' justifyContent='end' gap={1}>
              {find.branch.length === 0 ? null : (
                <MDButton
                  variant='gradient'
                  color='success'
                  onClick={excel}
                  disabled={excelLoading}
                >
                  {excelLoading ? (
                    <>
                      <CircularProgress size={16} color='inherit' sx={{ mr: 1 }} />
                      Loading...
                    </>
                  ) : (
                    <>
                      <Icon>table_view</Icon>&nbsp;Excel
                    </>
                  )}
                </MDButton>
              )}
            </MDBox>
          </Grid>
        </Grid>
      </Card>
    );
  };

  const renderList = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} md={2} lg={1}>
            <MDButton
              variant='contained'
              color='dark'
              size='large'
              fullWidth
              sx={{ pt: 1.6, pb: 1.6 }}
              href='/report_power_bi'
            >
              <Icon>content_paste_search</Icon>
            </MDButton>
          </Grid>
          <Grid item xs={12} sm={9} md={10} lg={11}>
            {renderSearch()}
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ minHeight: 400 }}>
              <Table aria-label='datatable table'>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={initHeader.length} align='center'>
                        ไม่พบข้อมูลกรุณาเลือกสาขา
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {record.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell align='left'>{row.branch_name}</TableCell>
                      <TableCell align='left'>{row.sku}</TableCell>
                      <TableCell align='left'>{row.product_name}</TableCell>
                      <TableCell align='left'>{row.unit_name}</TableCell>
                      <TableCell align='right'>
                        {Func.numberDisplay(row.quantity_balance)}
                      </TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.quantity)}</TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.total)}</TableCell>
                      <TableCell align='right'>{row.rank}</TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.avg_qty)}</TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.min_doh)}</TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.max_doh)}</TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.min_qty)}</TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.max_qty)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox display='flex' justifyContent='space-between' alignItems='flex-start'>
                <MDButton variant={show ? 'contained' : 'outlined'} color='dark' onClick={openShow}>
                  {t(`element.show_record`, { num: find.perPage })}&nbsp;
                  <Icon>keyboard_arrow_down</Icon>
                </MDButton>
                {renderShow}
                <Pagination
                  count={pageTotal}
                  variant='outlined'
                  color='secondary'
                  showFirstButton
                  showLastButton
                  page={pageNo || 1}
                  onChange={(e, p) => view({ ...find, page: p })}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang || 'th');

    init();
  }, [id]);
  return (
    <MDBox>
      <Navbar route={[t(`menu.report_power_bi`), t(`menu.${mod}`)]} />
      {renderList()}
      {renderLoading()}
    </MDBox>
  );
}

export default RPDOH;
